import { useAtom } from "jotai";
import { noop } from "lodash";
import { useCallback, useEffect } from "react";
import { match } from "ts-pattern";

import { CompanyForm } from "./components/company-form/company-form.component";
import { ConfirmationPage } from "./components/confirmation-page/confirmation-page.component";
import { SMSForm } from "./components/sms-form/sms-form.component";
import {
  completionStatusAtom,
  companyFormCompletedAtom,
  pagesAtom,
  smsCompletedAtom,
} from "./restaurant-equippers.state";
import { Pages } from "./restaurant-equippers.types";

export function Widget() {
  const [page, setPage] = useAtom(pagesAtom);
  const [completionStatus] = useAtom(completionStatusAtom);
  const [, setSmsCompleted] = useAtom(smsCompletedAtom);
  const [, setCompanyFormCompleted] = useAtom(companyFormCompletedAtom);

  const skipWidget = useCallback((): void => {
    window.theme.RestaurantEquippersUtils.handleNextSweepFlowStep();
  }, []);

  useEffect(() => {
    match(completionStatus)
      .with(null, skipWidget)
      .with({ sms_completed: true, company_form_completed: true }, () => {
        setSmsCompleted(true);
        setCompanyFormCompleted(true);
        setPage(Pages.CONFIRMATION);
      })
      .with(
        { sms_completed: true, company_form_completed: false },
        ({ sms_completed }) => {
          setSmsCompleted(sms_completed);
          setPage(Pages.COMPANY_FORM);
        }
      )
      .with(
        { sms_completed: false, company_form_completed: true },
        ({ company_form_completed }) => {
          setCompanyFormCompleted(company_form_completed);
        }
      )
      .with({ sms_completed: false, company_form_completed: false }, noop)
      .exhaustive();
  }, [
    completionStatus,
    setPage,
    setSmsCompleted,
    setCompanyFormCompleted,
    skipWidget,
  ]);

  return (
    <div className="re__optin">
      {match(page)
        .with(Pages.SMS_FORM, () => <SMSForm />)
        .with(Pages.COMPANY_FORM, () => <CompanyForm />)
        .with(Pages.CONFIRMATION, () => <ConfirmationPage />)
        .exhaustive()}
    </div>
  );
}
